// Template205: Bangkok - Consejos útiles página 2 (Tips2.jsx). borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template205 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";

	const headerText =
		page?.texts?.[0]?.content ?? "Consejos útiles para viajar a Bangkok";
	const platosTitle = page?.texts?.[1]?.content ?? "Platos que debes probar";
	const platosHtml = page?.texts?.[2]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};
	const stickerUrl = getCanvasImageUrl("sticker");
	const actualHeaderColor = headerBackgroundColor || "#E8A838";
	const tips =
		Array.isArray(page?.data?.tips)
			? page.data.tips
			: Array.isArray(page?.data?.data?.tips)
			? page.data.data.tips
			: [];

	const blockStyle = {
		backgroundColor: "#fff",
		borderRadius: "12px",
		padding: "12px 14px",
		display: "flex",
		alignItems: "center",
		gap: "10px",
		border: "2px solid #d9e6de",
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
			</Box>
			<Box
				data-block-id="text-1"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					position: "relative",
					marginTop: isSmallScreen ? 3 : 2,
				}}
			>
				{tips.map((tip, i) => (
					<Box key={i} data-block-id={`text-${i + 2}`} sx={blockStyle}>
						<Box sx={{ fontSize: 18 }}>{tip.icono ?? "🌶️"}</Box>
						<Box sx={{ fontSize: 13, color: contentColor }}>{tip.texto}</Box>
					</Box>
				))}
				{(platosTitle || platosHtml) && (
					<Box
						data-block-id="text-platos"
						sx={{
							backgroundColor: "#FFF3CD",
							border: "3px solid #E8A838",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 13,
							color: "#333",
							position: "relative",
						}}
					>
						{stickerUrl && (
							<Box
								component="img"
								src={stickerUrl}
								alt=""
								sx={{
									width: isSmallScreen ? 100 : 100,
									position: "absolute",
									top: isSmallScreen ? 160 : 20,
									right: isSmallScreen ? -10 : -9,
								}}
							/>
						)}
						{platosTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: "13px",
									fontWeight: 700,
									color: "#E8A838",
									textTransform: "uppercase",
								}}
							>
								{platosTitle}
							</Box>
						)}
						{platosHtml && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.6 }}
								dangerouslySetInnerHTML={{ __html: platosHtml }}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template205.thumbnail = "/images/template-1.png";
export default Template205;
